<template>
  <el-main id="admin-meeting-teams-send">
    <h3 class="section-title green-left-head title-margin">
      総会にメッセージ送信
    </h3>
    <el-col :span="20">
      <el-form ref="form" :model="formData" label-width="20%" :rule="rules">
        <el-form-item label="テンプレート" prop="teamsMessageTemplate">
          <el-select
            v-model="formData.teamsMessageTemplate"
            @change="onTeamsMessageTemplateChange"
          >
            <el-option
              v-for="item in teamsMessageTemplates.templateList"
              :key="item.name"
              :label="item.title"
              :value="item.name"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="送信メッセージ" prop="message">
          <el-input
            v-model="formData.message"
            type="textarea"
            :rows="2"
            :placeholder="messagePlaceholder"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="checkForm">送信</el-button>
          <el-button @click="$router.push({ name: 'admin_meeting_index' })"
            >キャンセル</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-button
            v-for="(item, i) in teamsMessageTemplates.messageTemplateList"
            :key="i"
            style="width: 10em; margin: 0.5em;"
            @click="onMessageTemplateClick(item)"
            >{{ item.title }}</el-button
          >
        </el-form-item>
      </el-form>
    </el-col>
  </el-main>
</template>

<script>
import authHeader from "../../../services/auth-header";
import { mapState } from "vuex";
import store from "../../../store";
import meetingService from "../../../services/meeting.service";

// import store from "../../../store";
export default {
  name: "admin_meeting_teams_send",
  store,
  mounted: async function() {
    // await this.$msal.handleRedirectPromise().then(
    //   function(res) {
    //     if (res !== null) {
    //       // ログイン済み
    //       this.$msal.setActiveAccount(res.account);
    //       this.$store.dispatch("msAccount/loginMsAccount", res.account);
    //     } else {
    //       // ログイン済みアカウントを確認
    //       var activeAccount = this.$msal.getActiveAccount();
    //       this.$store.dispatch("msAccount/loginMsAccount", activeAccount);
    //     }
    //   }.bind(this),
    // );
    await this.$store.dispatch("msAccount/initMsAccount");
    this.$store.dispatch("msAccount/initMsAccount");
    // テンプレートリスト読込
    await meetingService.teamsMessageTemplates(this.param).then(
      function(res) {
        this.teamsMessageTemplates = res;
        res.templateList.map(item => {
          if (item.default) {
            this.formData.teamsMessageTemplate = item.name;
            this.formData.message = item.defaultMessage;
          }
        });
      }.bind(this),
    );
  },
  data() {
    return {
      dialogVisible: false,
      teamsMessageTemplates: [],
      messagePlaceholder: "",
      rules: {
        teamsMessageTemplate: [
          {
            required: true,
            message: "テンプレートを選択してください。",
            trigger: "blur",
          },
        ],
        message: [
          {
            required: true,
            message: "テンプレートを選択してください。",
            trigger: "blur ",
          },
        ],
      },
      formData: {
        message: "",
        teamsMessageTemplate: "",
      },
    };
  },
  computed: {
    header: function() {
      return authHeader();
    },
    ...mapState({
      teamsAccount: function(state) {
        return state.teamsAccount.teamsAccount;
      },
    }),
    param: function() {
      return this.$route.params.id;
    },
  },
  methods: {
    onTeamsMessageTemplateChange() {
      this.teamsMessageTemplates.templateList.map(
        function(item) {
          console.log(item);
          console.log(this.formData.teamsMessageTemplate);
          if (item.name == this.formData.teamsMessageTemplate) {
            this.formData.teamsMessageTemplate = item.name;
            this.formData.message = item.defaultMessage;
          }
        }.bind(this),
      );
    },
    checkForm() {
      if (!this.formData.teamsMessageTemplate) {
        alert("テンプレートを入力してください。");
        return false;
      }
      if (!this.formData.message) {
        alert("送信メッセージを入力してください。");
        return false;
      }
      meetingService.sendTeamsMessage(
        this.param,
        this.formData.teamsMessageTemplate,
        this.formData.message,
      );
    },

    onMessageTemplateClick(item) {
      console.log(item);
      this.formData.message = item.message;
    },
  },
};
</script>

<style>
input[type="text"] {
  width: 100%;
}
</style>
